import React, {PureComponent} from 'react';

import {Classes, Overlay, Collapse, Button, MenuItem, Callout} from "@blueprintjs/core";
import {Link} from "react-router-dom";
import {getCurrentUserId, getJwt} from "../../services/authService";
import http from "../../services/httpService";
import toastr from "toastr";
import InputRegular from '../common/InputRegular';

export default class TeamsModals extends PureComponent {
    state = {
        overlayIsOpen: false,
        done: false,
        team_name: this.props.team_name || "",
        team_id: this.props.team_id || "",
        spinnerActive: false,
        errors: {},
        fieldsCheckActive: false,
        errorsList: [],
        selectedTeamId: '',
        selectedTeamName: '',
    }
    handleClose = () => {
        this.setState({
            overlayIsOpen: false,
        })
    }

    getEmailsFromInputs = () => {
        const collection = document.getElementsByTagName("input");
        const inputs = [...collection];

        const emails = inputs.map(input => {
            if (input.value) {
                return input.value;
            } else {
                return null
            }
        });
        return emails.filter(function (el) {
            return el != null;
        });
    };


    showInviteLink = () => {
        let show = this.state.showLink;
        show = show !== true;
        this.setState({
            showLink: show
        })
    };

    selectTeam = (id, team_name) => {
        // console.log(id);
        this.setState({
            selectedTeamId: id,
            selectedTeamName: team_name
        })
    };

    doSubmit = async (e) => {
        this.setState({fieldsCheckActive: true})
        const data = this.state.data;
        const team_id = this.state.team_id;
        // console.log('data: ', data);
        // console.log('teamId: ', team_id);
        // console.log('emails: ', emails);


        this.setState({spinnerActive: true})
        if (this.props.type === 'reassignProject') {
            try {
                const result = await http.post('api/user/' + this.props.user.id + '/team/feed/' + this.props.project_id,
                    {team_id: this.state.selectedTeamId}, {headers: {authorization: getJwt()}});
                this.props.getTeams();
                this.setState({
                    spinnerActive: false,
                });
                this.props.handleClose();
            } catch (e) {
                this.setState({
                    spinnerActive: false,
                });
                toastr.error("Reassigning Workspace to another team was unsuccessfull")
            }

        } else if (this.props.type === 'deleteTeam') {
            try {
                const result = await http.delete('api/user/' + this.props.user.id + '/team/' + this.props.team_id, {headers: {authorization: getJwt()}});
                this.props.getTeams();
                this.setState({
                    spinnerActive: false,
                });
                this.props.handleClose();
            } catch (e) {
                this.setState({
                    spinnerActive: false,
                });
                toastr.error("Team wasn't deleted, please try again.")
            }
        } else if (this.props.type === 'removeAdminFromTeam') {
            try {
                if (this.props.isPendingAdmin) {
                    const result = await http.delete('api/user/' + this.props.user.id + '/team/' + this.props.team_id + '/pending_admin/' + this.props.selectedAdmin.id, {headers: {authorization: getJwt()}});
                } else {
                    const result = await http.delete('api/user/' + this.props.user.id + '/team/' + this.props.team_id + '/admin/' + this.props.selectedAdmin.user_id_hash, {headers: {authorization: getJwt()}});
                }
                this.props.getTeams();
                this.setState({
                    spinnerActive: false,
                });
                this.props.handleClose();
            } catch (e) {
                this.setState({
                    spinnerActive: false,
                });
                toastr.error("Admin wasn't removed, please try again.")
            }
        } else if (this.props.type === 'removeAdminFromProject') {
            try {
                if (this.props.isPendingAdmin) {
                    const result = await http.delete('api/user/' + this.props.user.id + '/feed/' + this.props.project_id + '/pending_admin/' + this.props.selectedAdmin.id, {headers: {authorization: getJwt()}});
                } else {
                    const result = await http.delete('api/user/' + this.props.user.id + '/feed/' + this.props.project_id + '/admin/' + this.props.selectedAdmin.user_id_hash, {headers: {authorization: getJwt()}});
                }
                this.props.getTeams();
                this.setState({
                    spinnerActive: false,
                });
                this.props.handleClose();
            } catch (e) {
                this.setState({
                    spinnerActive: false,
                });
                toastr.error("Team wasn't deleted, please try again.")
            }
        } else if (this.props.type === 'renameTeam' && this.state.team_name) {
            try {
                const result = await http.patch('api/user/' + this.props.user.id + '/team/' + this.props.team_id,
                    {team_name: this.state.team_name}, {headers: {authorization: getJwt()}});
                this.props.getTeams();
                this.setState({
                    spinnerActive: false,
                });
                this.props.handleClose();
            } catch (e) {
                this.setState({
                    spinnerActive: false,
                });
                toastr.error("Team wasn't deleted, please try again.")
            }
        }
        if (!window.location.href.indexOf('team')) {
            this.props.updateWorkspaceData()
        }
    };

    updateErrorsList = async (error, id) => {
        let errorsList = await this.state.errorsList;
        errorsList[parseInt(id) - 1] = await error;
        await this.setState({errorsList})
        // console.log('errorsList: ', errorsList)
    }

    componentDidMount() {
        // console.log('props u teams modals: ', this.props)
        this.setState({
            overlayIsOpen: this.props.showModal
        })
    }

    componentDidUpdate() {
        // console.log('props u teams modals: ', this.props)
    }

    render() {

        return (
            <Overlay
                // onClose={this.props.handleClose}
                className={this.state.billingDetailsOpen ? (Classes.OVERLAY_SCROLL_CONTAINER + ' padding-top-400') : Classes.OVERLAY_SCROLL_CONTAINER}
                // isOpen={this.state.overlayIsOpen}
                isOpen={this.props.showModal}
            >
                <div className="modal-field-payment"
                     style={{width: this.props.width || '60%', maxWidth: this.props.maxWidth || '100%'}}>
                    <div className="add-payment-method-modal-container">

                        <div className='modal-title'>
                            <p className="modal-close-button" onClick={this.props.handleClose}><i
                                className="fas fa-times"></i></p>
                            <h2>{this.props.type === 'renameTeam' ? 'Rename team' : this.props.type === 'deleteTeam' ?
                                'Delete team' : this.props.type === 'removeAdminFromTeam' ? 'Remove admin from team' :
                                    this.props.type === 'removeAdminFromProject' ? 'Remove admin from workspace' : 'Reassign workspace to another team'
                            }</h2>
                        </div>
                        <div className='modal-main'>
                            <div className='margin-top-20 margin-bottom-10'>
                                {this.props.type === 'renameTeam' ? '' : this.props.type === 'deleteTeam' ?
                                    <p className='m-m-b'>Are you certain that you want to delete
                                        team: <strong>{this.props.team_name}</strong></p>
                                    : this.props.type === 'removeAdminFromTeam' ?
                                        <p className='m-m-b'>Are you certain that you want to
                                            remove {this.props.selectedAdmin.name ? 'admin' : ''}
                                            <strong>{this.props.isPendingAdmin ? 'Pending Admin ' : this.props.selectedAdmin.first_name} {this.props.selectedAdmin.last_name || ''} </strong>
                                            from team <strong>{this.props.team_name}</strong></p> :
                                        this.props.type === 'removeAdminFromProject' ?
                                            <p className='m-m-b'>Are you certain that you want to remove
                                                admin <strong>{this.props.selectedAdmin.name || this.props.selectedAdmin.email} </strong>
                                                from workspace <strong>{this.props.project_name}</strong></p> :
                                            <p className='m-m-b'>Choose to which team you want to
                                                reassign <strong>{this.props.project_name}</strong></p>
                                }

                                <div id='team-members'>

                                    {this.props.type === 'renameTeam' ?
                                        <InputRegular
                                            id={'1'}
                                            label1=""
                                            label2=""
                                            placeholder=""
                                            type='text'
                                            onChange={value => this.setState({team_name: value})}
                                            value={this.state.team_name}
                                            required={true}
                                            fieldsCheckActive={this.state.fieldsCheckActive}
                                            updateErrorsList={this.updateErrorsList}
                                            errorMessage="Please enter team name"
                                        />
                                        :
                                        ''
                                    }
                                </div>
                                {this.props.type === 'reassignProject' ?
                                    <div className='margin-top-10 margin-bottom-30'>
                                        <div id='teams'>
                                            {
                                                this.props.teams ? this.props.teams.map(team => {

                                                        return this.state.selectedTeamId === team.id ?

                                                            <p key={team.id}
                                                               onClick={() => this.selectTeam(team.id, team.team_name)}
                                                               className='reassign-project-team selected'>{team.team_name}
                                                            </p>

                                                            :

                                                            <p key={team.id}
                                                               onClick={() => this.selectTeam(team.id, team.team_name)}
                                                               className='reassign-project-team'>{team.team_name}
                                                            </p>
                                                    }
                                                ) : ''
                                            }
                                            {
                                                this.props.teams_in ? this.props.teams_in.map(team => {

                                                        return this.state.selectedTeamId === team.id ?

                                                            <p key={team.id}
                                                               onClick={() => this.selectTeam(team.id, team.team_name)}
                                                               className='onboarding-team selected'>{team.team_name}
                                                            </p>

                                                            :

                                                            <p key={team.id}
                                                               onClick={() => this.selectTeam(team.id, team.team_name)}
                                                               className='onboarding-team'>{team.team_name}
                                                            </p>
                                                    }
                                                ) : ''
                                            }
                                        </div>
                                    </div>
                                    :
                                    ''
                                }

                                <div className='justify-content-space flex-direction-row margin-bottom-20'>
                                    <button onClick={this.props.handleClose} className='btn-white-border'>Cancel
                                    </button>
                                    {!this.state.spinnerActive ?
                                        <button
                                            // disabled={this.validate()}
                                            onClick={this.doSubmit}
                                            name="invite_team"
                                            id="change_team"
                                            type="button"
                                            className={this.props.type === 'deleteTeam' ? 'btn-danger' : 'btn-action'}
                                        >{
                                            this.props.type === 'renameTeam' ? 'Rename Team' :
                                                this.props.type === 'deleteTeam' ? 'Delete Team' :
                                                    (this.props.type === 'removeAdminFromTeam') || (this.props.type === 'removeAdminFromProject') ?
                                                        'Remove Admin' : 'Reassign Workspace'
                                        }</button>
                                        :
                                        <button
                                            className={this.props.type === 'deleteTeam' ? 'btn-danger btn-spinner' : 'btn-action btn-spinner'}
                                            disabled={true}>{
                                            this.props.type === 'renameTeam' ? 'Rename Team' :
                                                this.props.type === 'deleteTeam' ? 'Delete Team' :
                                                    (this.props.type === 'removeAdminFromTeam') || (this.props.type === 'removeAdminFromProject') ?
                                                        'Remove Admin' : 'Reassign Workspace'
                                        } <i className='fa fa-spin fa-spinner'></i></button>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                    {/*{console.log('props: ', this.props)}*/}
                </div>
            </Overlay>
        )
    }
}